import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ReloadTriggerService {
  private reload = new Subject<void>();
  reload$ = this.reload.asObservable().pipe(startWith(true));

  triggerReload() {
    // todo: this breaks saving current forms, needs rework
    this.reload.next();
  }
}
